import { render, staticRenderFns } from "./AtualizarDados.vue?vue&type=template&id=c3e4a696&scoped=true"
import script from "./AtualizarDados.vue?vue&type=script&lang=js"
export * from "./AtualizarDados.vue?vue&type=script&lang=js"
import style0 from "./AtualizarDados.vue?vue&type=style&index=0&id=c3e4a696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e4a696",
  null
  
)

export default component.exports